import { atom } from "recoil";

export const wishQuantity = atom({
    key: "wishQuantity",
    default: 0,
});